import { IconButton, Box as MUIBox, styled, Typography } from '@mui/material'

import { Container } from '../'

export const Content = styled(Container)(({ theme }) => ({
  borderRadius: '8px',
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  height: '92%',
  maxHeight: '100%',
  overflowY: 'hidden',
  padding: 32,
  width: '92%',

  [theme.breakpoints.down('md')]: {
    maxHeight: '100%',
    width: '92%'
  }
}))

export const CloseButton = styled(IconButton)(() => ({
  position: 'absolute',
  right: 5,
  top: 5
}))

export const Box = styled(MUIBox)(() => ({
  display: 'flex',
  flexDirection: 'column'
}))

export const Header = styled(MUIBox)(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    width: '100%',
    gap: '0.625rem'
  }
}))

export const Heading = styled(Typography)`
  align-items: center;
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
`

export const TableWrapper = styled('div')(({ theme }) => ({
  flex: 1,
  height: '100%',
  overflowY: 'auto',
  '& tr:hover': {
    cursor: 'pointer',
    background: theme.palette.neutral[800]
  }
}))

export const EmptyStateWrapper = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  width: '100%'
}))
